import client from '@/api/client';
import { BASE_URL } from '@/constants';
import { objectToQueryString } from '@/utils/sfaas_temp';

export default {
	async getCommCodes(codeType) {
		try {
			const response = await client.get(`${BASE_URL}/cc/v1/plants/undefined/commonCodes?commCdType=${codeType}`);
			return response?.data || null;
		} catch (error) {
			throw error.response?.data;
		}
	},
	async getPowAttrList({ searchParams, currentPage, pageUnit }) {
		const queryStr = objectToQueryString({
			plntCd: searchParams.plntCd,
			powCd: searchParams.powCd,
			currentPage,
			pageUnit
		});
		try {
			const response = await client.get(`${BASE_URL}/comm/qmsbase/powAttr/v1/powAttrs${queryStr}`);
			return response?.data || null;
		} catch (error) {
			throw error.response?.data;
		}
	}
};
